<template>
  <LazyModulesKursusCertificate>
    <slot />
  </LazyModulesKursusCertificate>
</template>
